import { render, staticRenderFns } from "./MainScroll.vue?vue&type=template&id=9f6b48de&scoped=true&"
import script from "./MainScroll.vue?vue&type=script&lang=js&"
export * from "./MainScroll.vue?vue&type=script&lang=js&"
import style0 from "./MainScroll.vue?vue&type=style&index=0&id=9f6b48de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6b48de",
  null
  
)

export default component.exports